import { Deal } from 'modules/domain/deal/types'
import { endpoints } from 'modules/endpoints'
import { FC, useEffect, useState } from 'react'
import { refetchFunc, useSingleEntity } from 'modules/domain/common/hooks'

import { DealRailwayData } from '../types'
import { DealRailwayModal } from './DealRailwayModal'
import { Icons, Progress } from '@agro-club/agroclub-shared'
import { AButton } from 'views/components/Analytics'

type Props = {
  deal: Deal
  refetch: refetchFunc
}

export const DealRailwayEditBtn: FC<Props> = ({ deal, refetch }) => {
  const [modalOpen, setModalOpen] = useState(false)
  const [dataRequested, setDataRequested] = useState(false)
  const [progress, railwayData] = useSingleEntity<DealRailwayData>(
    dataRequested ? endpoints.dealRailWayData(deal.id) : undefined,
  )
  // it is required to prevent modal blicking when progress was not reset yet
  useEffect(() => {
    if (progress === Progress.SUCCESS && dataRequested) {
      setModalOpen(true)
    }
  }, [dataRequested, progress])

  return (
    <>
      <AButton
        id="edit"
        size="medium"
        color="secondary"
        background="none"
        Icon={Icons.IconEdit}
        onClick={() => setDataRequested(true)}
      />
      {modalOpen && (
        <DealRailwayModal
          deal={deal}
          railwayData={railwayData}
          refetch={refetch}
          onClose={() => {
            setModalOpen(false)
            setDataRequested(false)
          }}
        />
      )}
    </>
  )
}
